import { MatchesController, MatchesControllerForm } from "./matches_controller";
import { CombinationRankingTableController } from "./combination_ranking_table_controller";
import { RelatedCombinationRecipesController } from "./related_combination_recipes_controller";
import { MatchesForm } from "../view/matches_form";

class CookMatchesController extends MatchesController {
  constructor() {
    super();
    this.form = new MatchesControllerForm();
    this.view = new MatchesForm();
    this.combinationRankingTableController =
      new CombinationRankingTableController(
        this.form,
        "kci",
        this.rankingTableElement(),
      );
    this.relatedRecipesController = new RelatedCombinationRecipesController();
  }
}

export { CookMatchesController };
